import React from "react";
import { useApolloClient } from "@apollo/client";
import { useModifyCrmUserAvatarMutation } from "../../main-routes/crm/CrmPersonProfile.generated.js";
import { Attachment } from "../attachments/helpers.js";
import { Link, Stack, Typography } from "@mui/material";
import { UserAvatar } from "../users/UserAvatar.js";
import { Link as RouterLink } from "react-router-dom";
import { CrmPersonAvatarAndTitleForm_CrmPersonFragment } from "./CrmPersonAvatarAndTitleForm.generated.js";

interface Props {
  crmPerson: CrmPersonAvatarAndTitleForm_CrmPersonFragment;
}

export const CrmPersonAvatarAndTitleForm = ({ crmPerson }: Props) => {
  const client = useApolloClient();

  const [modifyCrmUserAvatar, { loading: modifyCrmUserLoading }] =
    useModifyCrmUserAvatarMutation({
      client,
    });

  async function onAttachment(attachment: Attachment | null) {
    await modifyCrmUserAvatar({
      variables: {
        users: [
          {
            id: crmPerson.id,
            avatar: attachment
              ? {
                  url: attachment.url,
                  title: attachment.title,
                  mimeType: attachment.mimeType,
                }
              : null,
          },
        ],
      },
    });
  }
  return (
    <Stack direction="column" spacing={1}>
      <Stack
        direction="row"
        sx={{
          justifyContent: "center",
        }}
      >
        <UserAvatar
          userAvatar={crmPerson}
          size="l"
          onAttachment={onAttachment}
          disabled={modifyCrmUserLoading}
        />
      </Stack>
      <Stack direction="column" spacing={0.5}>
        <Typography variant="h2" align="center">
          {crmPerson.firstname} {crmPerson.familyname}
        </Typography>
        <Link
          variant="body2"
          component={RouterLink}
          to={`/crm/organisations/${crmPerson.crmCompany.id}`}
          sx={{ alignSelf: "center", textAlign: "center" }}
        >
          {crmPerson.crmCompany.title}
        </Link>
      </Stack>
    </Stack>
  );
};

export const CrmPersonAvatarAndTitleData = ({ crmPerson }: Props) => {
  return (
    <Stack direction="column" spacing={1}>
      <Stack
        direction="row"
        sx={{
          justifyContent: "center",
        }}
      >
        <UserAvatar userAvatar={crmPerson} size="l" />
      </Stack>
      <Stack direction="column" spacing={0.5}>
        <Typography variant="h2" align="center">
          {crmPerson.firstname} {crmPerson.familyname}
        </Typography>
        <Link
          variant="body2"
          component={RouterLink}
          to={`/crm/organisations/${crmPerson.crmCompany.id}`}
          sx={{ alignSelf: "center", textAlign: "center" }}
        >
          {crmPerson.crmCompany.title}
        </Link>
      </Stack>
    </Stack>
  );
};
